import React from 'react';
import '../template-file-css/document-file-template.css';


export const LSS_StatementOfProviderChoice = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LSS_StatementOfProviderChoice' className='file-pdf-document'>
            <div className='file-template'>
            <p>
             I,  <input type="text" id="txtName1" name="txtName1" className='add-only' />
                (Parent/Legal Guardian, if minor) have selected to receive the following
                 service(s) from <strong>Life Solutions South:</strong> <br /><br />
                 Check all that Apply:  <br /> <br />
                 <input type="checkbox" name="cbProviderChoice_1" id="cbProviderChoice_1" className='add-only' value="ProviderChoice_1" />Diagnostic Evaluation and Diagnostic Evaluation Update <br />
                 <input type="checkbox" name="cbProviderChoice_2" id="cbProviderChoice_2" className='add-only' value="ProviderChoice_2" />Community Psychiatric Service Treatment (CPST) <br />
                 <input type="checkbox" name="cbProviderChoice_3" id="cbProviderChoice_3" className='add-only' value="ProviderChoice_3" /> Psychotherapy (Individual, Family, Group, Crisis) <br />
                 <input type="checkbox" name="cbProviderChoice_4" id="cbProviderChoice_4" className='add-only' value="ProviderChoice_4" /> Psychoeducation Support Services (Therapeutic Behavioral Services, Psychosocial Rehabilitation) <br />
                 <input type="checkbox" name="cbProviderChoice_5" id="cbProviderChoice_5" className='add-only' value="ProviderChoice_5" /> Assertive Community Treatment (ACT) <br />
                 <input type="checkbox" name="cbProviderChoice_6" id="cbProviderChoice_6" className='add-only' value="ProviderChoice_6" />Intensive Home-Based Therapy (IHBT)  <br />
                 <input type="checkbox" name="cbProviderChoice_7" id="cbProviderChoice_7" className='add-only' value="ProviderChoice_7" />Substance Use Disorder Assessment and ASAM <br />
                 <input type="checkbox" name="cbProviderChoice_8" id="cbProviderChoice_8" className='add-only' value="ProviderChoice_8" />Substance Use Disorder Services (Case Management; Psychotherapy; Individual Counseling; Group) <br />
                 <input type="checkbox" name="cbProviderChoice_9" id="cbProviderChoice_9" className='add-only' value="ProviderChoice_9" />Intensive Outpatient Treatment <br />
                 <input type="checkbox" name="cbProviderChoice_10" id="cbProviderChoice_10" className='add-only' value="ProviderChoice_10" />Laboratory Analysis  <br />
                 <input type="checkbox" name="cbProviderChoice_11" id="cbProviderChoice_11" className='add-only' value="ProviderChoice_11" /> Medication Management  <br />
                 I attest that I have been provided with the information necessary to make an informed choice about service, informed
                 about the range of other services in a way that in non-coercive and protects my right to self-determination. <br /> <br />
                 My selection of a service provider was based solely upon my identified needs, diagnosis, preference, and provider
                 availability. <br /> <br />
                 By signing this Statement of Provider Choice, I acknowledge that I was given choice of provider and that the screening
                 discussed location, available times, specialty, culture and linguistic preferences with me. <br /> <br />
             </p>
             <table>
                    <tr>
                        <td className='w-450 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-450 small">Client Name (Printed)</td>
                    </tr>
                    <tr>
                        <td className='w-450 signature'>&nbsp;
                        </td>
                        <td className='w-300 signature'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="w-450 small">Client Signature
                        </td>
                        <td className="w-300 small">Date:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450 signature'>&nbsp;
                        </td>
                        <td className='w-300 signature'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="w-450 small">Parent/Legal Guardian Signature
                        </td>
                        <td className="w-300 small">Date:
                        </td>
                    </tr>
                </table>
            </div>
        </form>

    )
}